const MainLayout = (props:any) => {
    return (<div className="w-screen h-auto scroll-smooth">
    <div className="fixed top-0 left-0 w-full h-screen m-0 p-0 -z-10 bg-black">
      <div id="stars" className="animate-pulse drop-shadow-xl"></div>
      </div>
      <div>{props.children}</div>
      </div>)
}

export default MainLayout